<template>
    <el-container v-wechat-title="title" :style="{ height: this.screenHeight + 'px' }">
        <el-aside :width="collapse ? '64px' : '264px'" class="cus-sider" ref="slider" v-if="!isOnlyShowMainContainer">
            <div style="height: 47px; display: flex; align-items: center; justify-content: flex-start; background: white; border-bottom: solid 0.5px lightgray; padding-left: 15px">
                <img v-if="showLogo" style="height: 32px; width: 32px; vertical-align: text-bottom" :src="Logo" class="sidebar-logo" />
                <span v-show="!collapse" class="sidebar-title" style="font-size: 30px; color: var(--logo-text-color, #009688)">
                    &nbsp;{{ systemAbbreviation }}
                    <!-- <sup style="font-size:14px">&nbsp;7.0</sup> -->
                </span>
            </div>
            <div :style="{ height: `${this.screenHeight - 87 + (this.collapse ? 40 : 0)}px` }">
                <div style="width: 62px; float: left" class="workbar">
                    <Workbar :collapse="collapse"></Workbar>
                </div>
                <div class="height-p100" style="width: 200px; float: left; background: white" v-if="!collapse">
                    <slot name="ref_content"></slot>
                </div>
            </div>
            <div style="clear: both"></div>
            <div style="background: white; padding: 10px 0" v-if="companyName && companyName.length > 0 && companyName.trim().length > 0" class="fg-info">{{ companyName }}</div>
        </el-aside>
        <el-container>
            <el-header class="cus-header">
                <el-row type="flex" align="top">
                    <el-col :xl="19" :lg="17" :md="16">
                        <el-row>
                            <el-col :xl="1" :lg="1" :md="2" class="collapse" style="line-height: 48px" v-show="!isOnlyShowMainContainer"
                                ><i :class="collapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="triggerCollapse()"></i
                            ></el-col>
                            <el-col :xl="23" :md="22">
                                <slot name="ref_header"></slot>
                            </el-col>
                        </el-row>
                    </el-col>

                    <el-col :xl="5" :lg="7" :md="8" style="text-align: right; padding-right: 10px; font-size: 16px; padding: 2px" v-show="!isOnlyShowMainContainer">
                        <Screenfull id="screenfull" class="right-menu-item hover-effect" style="display: inline-block; font-size: 16px" />
                        <el-popover placement="bottom-start" style="padding: 2px 0 0; display: inline-block" width="400" popper-class="cus-wardlist" trigger="click" v-model="display">
                            <div>
                                <div v-for="(hw, key) in org" :key="key">
                                    <span style="font-weight: bold"><font-awesome-icon icon="home" /> {{ key }}</span>
                                    <div style="padding: 5px 20px">
                                        <div v-for="(item, itemkey) in hw.detail" :key="itemkey">
                                            <span style="font-weight: bold">{{ itemkey }}</span>
                                            <div>
                                                <el-button
                                                    v-for="o_w in item"
                                                    :key="o_w.value"
                                                    size="mini"
                                                    :class="{ 'el-button--primary is-plain': o_w.value == active_ward.value }"
                                                    style="margin: 5px 0 5px 10px"
                                                    @click="activeWard(o_w)"
                                                    >{{ o_w.label }}</el-button
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <el-button slot="reference" round>
                                <!-- <span style="width:80px;display:block" class="ellipsis" >{{activeWardName}}</span> -->
                                {{ activeWardName }}
                            </el-button>
                        </el-popover>
                        <el-button class="pointer" style="padding: 0 10px; display: inline-block; height: 40px; text-align: center; vertical-align: middle">
                            <el-dropdown @command="dropDownAction" trigger="click">
                                <div style="line-height: 40px">
                                    <el-avatar :size="24" style="left: 0; top: 6px; position: absolute" :src="circleUrl"></el-avatar>
                                    <div style="display: inline-block; font-size: 16px; margin-left: 30px">
                                        <span class="hidden-md-and-down"
                                            >{{ username }}<span style="font-size:14px;">({{ (this.currentUser && this.currentUser.user_role) || '--' }})</span></span
                                        >
                                        <i class="el-icon-arrow-down"></i>
                                    </div>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="logout" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `user:logout`) != -1">注销</el-dropdown-item>
                                    <!-- <el-dropdown-item command="testRelogin" divided style="color: #E6A23C;">测试重新登录</el-dropdown-item> -->
                                    <el-dropdown-item command="alterPassword" divided>修改密码</el-dropdown-item>
                                    <el-dropdown-item v-for="extend in sendMessageExtendcomputed" :key="extend.value" :command="extend.value" divided>{{ extend.label }}</el-dropdown-item>
                                    <el-dropdown-item command="ResetHomePage" v-show="this.$router.currentRoute.name.indexOf(`portal`) !== -1" divided>重置首页</el-dropdown-item>
                                    <!--<el-dropdown-item command="changeLangEvent">切换语言</el-dropdown-item>-->
                                    <el-dropdown-item command="triggerTags" divided>
                                        <span v-if="enable_tagsview">隐藏快捷标签</span>
                                        <span v-else>显示快捷标签</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item command="change_theme_light" divided>主题 light</el-dropdown-item>
                                    <el-dropdown-item command="change_theme_dark">主题 dark</el-dropdown-item>
                                    <el-dropdown-item command="change_theme_his_blue">主题 blue</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-button>
                    </el-col>
                </el-row>
            </el-header>
            <slot></slot>
            <!-- <el-footer height="20px">
        <el-row>
          <el-col :span="16" :offset="4">
            copyright @上海米健信息技术有限公司
          </el-col>
          <el-col :span="4"></el-col>
        </el-row>
      </el-footer> -->
        </el-container>
        <AlterPassword :visible.sync="alterPasswordDialogVisible" :userid="(currentUser && currentUser.id) || 0"> </AlterPassword>
        <!-- <cus-dialog title="消息提醒" :visible.sync="messageObj.dialogFormVisible" width="40%" @confirm="supplementEvent()">
            <div class="margin10 margin-none-h align-left">这里放消息提醒</div>
        </cus-dialog> -->
        <!-- <el-dialog
            title="提示"
            modal="false"
            class="asdb"
            top="0"
            :visible.sync="messageObj.dialogFormVisible"
            width="40%"
            :before-close="handleClose"
            style="right: 0px; position: absolute; top: 0px; overflow: hidden"
        >
            <span>这是一段信息</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="messageObj.dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="messageObj.dialogFormVisible = false">确 定</el-button>
            </span>
        </el-dialog> -->
    </el-container>
</template>
<script>
import { mapGetters } from 'vuex'
import TagsView from '@/common/TagsView.vue'
import Screenfull from '@/common/Screenfull.vue'
import Workbar from './Workbar/Index.vue'
import AlterPassword from '@/components/SysUser/AlterPassword.vue'
// import { showExpiredDialog } from '@/utils/tokenExpiration'

export default {
    name: `Layout`,
    components: { TagsView, Screenfull, AlterPassword, Workbar },
    inject: [`reload`],
    props: {
        enable_tagsview: { type: Boolean, default: () => true },
        active: { type: String, default: () => `1` }, //  当前工作栏  见store.workbar
        isOnlyShowMainContainer: { type: Boolean, default: () => false } //  是否仅仅只显示患者右侧主区域内容，true:隐藏左侧患者列表和头部区域
    },
    data() {
        return {
            hospital: `演示医院`,
            title: `首页`,
            imgsrc: `../../static/img/avatar/default/doctor.png`,
            alterPasswordDialogVisible: false,
            display: false,
            active_id: undefined,
            isOnlyShowMain: this.$route.query.isOnlyShowMain,
            operating_room_id: undefined,
            flag: undefined,
            notifications: {},
            noticeDatas: [],
            needGetMessage: true,
            systemAbbreviation: this.$root.SystemAbbreviation,
            sendMessageExtend: this.$root.SendMessageExtend,
            messageNotifyHandlers: this.$root.MessageNotifyHandlers,
            messageNotifyInterval: this.$root.MessageNotifyInterval,
            emergencyAlertSettings: this.$root.EmergencyAlertSettings,
            recoveryVoiceBroadcast: this.$root.RecoveryVoiceBroadcast && this.$root.RecoveryVoiceBroadcast == `1`,
            urlActiveWard: this.$route.query.ward_id,
            messagetimer: null,
            timermessage: null,
            messageNotifychildNode: [],
            notifyPromise: Promise.resolve(),
            messageObj: {
                dialogFormVisible: true,
                msg: ``
            },
            useCa: this.$root.useCa,
            isCordova: false
        }
    },
    computed: {
        ...mapGetters([
            `currentUser`,
            `business`,
            `screenHeight`,
            `screenWidth`,
            `workbar`,
            `layout/collapse`,
            `layout/reset`,
            `layout/field_active`,
            `ward_auth`,
            `active_ward`,
            `localip/ipAddress`,
            `containerWidth`,
            `permissions`
        ]),
        collapse() {
            return this[`layout/collapse`]
        },
        reset() {
            return this[`layout/reset`]
        },
        sendMessageExtendcomputed() {
            if (this.sendMessageExtend != `` && this.sendMessageExtend != `0`) {
                let s = eval(`(` + this.sendMessageExtend + `)`)
                return s
            }
            return []
        },

        field_active: {
            get: function() {
                return this.active
                // return this["layout/field_active"] || this.active
            },
            set: function(newval) {
                // this.$emit("update:active", newval)
                let wf = _.find(this.workbar, { value: newval })
                this.$router.push(wf.link)
                // this.$store.commit("layout/SET_FIELD_ACTIVE", newval)
            }
        },
        username() {
            return (this.currentUser && this.currentUser.dic_worker_name) || `--`
        },
        circleUrl() {
            // 显示图片2种方式
            // return require('../assets/首页.jpg') // 1.显示src目录下图片
            return this.imgsrc // 2.显示src同级目下图片
        },
        org() {
            let all = _.groupBy(this.ward_auth, `group`)
            _.forEach(all, d => {
                d.detail = _.groupBy(d, `code`)
            })
            return all
        },
        activeWardName() {
            // 当区域store没有值时，直接返回--
            if (!this.ward_auth || this.ward_auth.length == 0) {
                return `--`
            }

            let sessionItem = sessionStorage.getItem(`active_ward`)
            // session中是否存在区域
            if (sessionItem) {
                // 存在 直接作用session中区域
                var activeWard = JSON.parse(sessionItem)
                this.$store.commit(`SET_ACTIVE_WARD`, activeWard)
            } else {
                // 存在,判断是否设置了区域
                if (this.active_id) {
                    let data = this.operating_room_id ? _.filter(this.ward_auth, { value: `ow_${this.active_id}` }) : _.filter(this.ward_auth, { value: `rw_${this.active_id}` })
                    this.$store.commit(`SET_ACTIVE_WARD`, data[0])
                } else {
                    this.$store.commit(`SET_ACTIVE_WARD`, this.ward_auth && this.ward_auth[0])
                }
            }
            // url传递了手术间，把系统右上角当前手术区设置成url设置的手术间
            if (this.ward_auth && this.ward_auth.length && this.urlActiveWard) {
                let data = this.operating_room_id ? _.filter(this.ward_auth, { value: `ow_${this.urlActiveWard}` }) : _.filter(this.ward_auth, { value: `rw_${this.urlActiveWard}` })
                if (data && data[0]) {
                    this.active_id = this.urlActiveWard
                    this.$store.commit(`SET_ACTIVE_WARD`, data && data[0])
                }
            }
            return this.active_ward && this.active_ward.label
        },
        Logo() {
            return `../../../static/img/${this.$root.LOGO || `logo.png`}`
        },
        companyName() {
            return this.$root.CompanyName
        },
        showLogo() {
            return `${this.$root.HideLogo || `0`}` !== `1`
        }
    },
    created() {
        // 获取本地IP地址
        this.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(() => {
            this.loadWorkstationConfig()
        })
        //  加载所有枚举
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        console.log(`=====计时器开始执行=======`)
    },
    mounted() {
        const that = this
        this.$store.dispatch(`ADD_CURRENTUSER`)
        window.onresize = () => {
            that.$store.commit(`setScreenHeight`, document.documentElement.clientHeight)
            that.$store.commit(`setScreenWidth`, document.documentElement.clientWidth)
        }
        if (this.speakFinish) {
            clearInterval(this.speakFinish)
        }
        if (window.cordova) {
            this.isCordova = true
        } else {
            this.isCordova = false
        }
        this.loadmessageNotifyHandlers()
        // isOnlyShowMain有值，证明是链接跳过来的，这是不做提醒
        if (that.messagetimer == null && this.isOnlyShowMain == undefined) {
            if (this.messageNotifyInterval && this.messageNotifyInterval > 0) {
                this.messagetimer = setInterval(function() {
                    // needGetMessage用来控制防止卡死，第一次请求返回后才去请求第二次
                    if (that.needGetMessage == true) {
                        that.loadMessageList()
                    }
                }, this.messageNotifyInterval * 1000)
            }
        }
        console.log(`quanxian`)
        console.log(this.permissions)
    },
    destroyed() {
        this.$notify.closeAll()
        this.notifications = {}
        clearInterval(this.messagetimer)
    },
    methods: {
        loadmessageNotifyHandlers() {
            let that = this
            console.log(`messageNotifyHandlers`)
            console.log(this.messageNotifyHandlers)
            if (this.messageNotifyHandlers != `` && this.messageNotifyHandlers != `0`) {
                let notifyHandlers = eval(`(` + this.messageNotifyHandlers + `)`)
                console.log(notifyHandlers)
                notifyHandlers.forEach(d => {
                    that.messageNotifychildNode.push(
                        this.$createElement(
                            `option`,
                            {
                                attrs: {
                                    value: d
                                },
                                style: {
                                    height: `30px`,
                                    'line-height': `30px`,
                                    'font-size': `20px`
                                }
                            },
                            d
                        )
                    )
                })
            }
        },
        loadMessageList() {
            let that = this
            that.needGetMessage = false
            let req = this.myaxios.getNoloading(
                `/api/Operation/MessageReceive/GetNotify?from=${this.$moment()
                    .add(-1, `Day`)
                    .format(`YYYY-MM-DD`)}&to=${this.$moment().format(`YYYY-MM-DD`)}`
            )
            req.then(data => {
                this.messages = _.take(
                    _.filter(data, d => {
                        return d.biz_message_content.enum_message_status === 1
                    }),
                    5
                )
                if (this.messages.length > 0) {
                    for (let key in this.notifications) {
                        let r = this.messages.find(s => s.biz_message_header_id == key)
                        if (r == null || r == undefined) {
                            this.notifications[key].close()
                            delete this.notifications[key]
                        }
                    }
                    let f = _.filter(this.messages, d => {
                        return d.is_read === false
                    })
                    if (f != null) {
                        if (that.noticeDatas.length == 0) {
                            f.forEach(d => {
                                if (d.biz_message_content.biz_type == `5`) {
                                    that.noticeDatas.push(d.biz_message_content.content)
                                }
                                if (d.biz_message_content.biz_type == `3` && that.recoveryVoiceBroadcast) {
                                    // 复苏申请要语音播报，播报内容存储配置
                                    that.noticeDatas.push(d.biz_message_content.content)
                                }
                            })
                        }
                        f.forEach(d => {
                            if (this.notifications[d.biz_message_header_id] == undefined) {
                                this.notifyPromise = this.notifyPromise.then(g => {
                                    let notify = this.$notify({
                                        title: d.biz_message_content.title,
                                        dangerouslyUseHTMLString: true,
                                        showClose: false,
                                        // message: `<strong>这是 <i>HTML</i> 片段</strong>`,
                                        message: this.$createElement(`div`, null, [
                                            this.$createElement(`div`, null, [
                                                this.$createElement(
                                                    `div`,
                                                    {
                                                        style: {
                                                            'max-height': `200px`,
                                                            overflow: `hidden`,
                                                            'overflow-y': `auto`,
                                                            'font-size': `14px`
                                                        }
                                                    },
                                                    d.biz_message_content.content
                                                )
                                            ]),
                                            this.$createElement(`div`, null, [
                                                this.$createElement(
                                                    `select`,
                                                    {
                                                        style: {
                                                            display: d.biz_message_content.biz_type == `5` ? `` : `none`,
                                                            'line-height': `30px`,
                                                            height: `30px`,
                                                            width: `80%`,
                                                            margin: `10px`
                                                        },
                                                        domProps: {
                                                            value: self.value
                                                        },
                                                        on: {
                                                            input: function(event) {
                                                                d.biz_message_content.handler_name = event.target.value
                                                            }
                                                        }
                                                    },
                                                    that.messageNotifychildNode
                                                )
                                            ]),
                                            this.$createElement(`div`, null, [
                                                this.$createElement(
                                                    `div`,
                                                    {
                                                        style: {
                                                            width: `50%`,
                                                            float: `left`,
                                                            'font-size': `16px`,
                                                            color: `black`,
                                                            'padding-top': `10px`
                                                        }
                                                    },
                                                    `发送人:${d.biz_message_content.sender}`
                                                )
                                            ]),
                                            this.$createElement(`div`, null, [
                                                this.$createElement(
                                                    `div`,
                                                    {
                                                        style: {
                                                            width: `50%`,
                                                            float: `right`,
                                                            'font-size': `16px`,
                                                            color: `black`,
                                                            'padding-top': `10px`
                                                        }
                                                    },
                                                    `时间:${this.$moment(d.receive_date).format(`MM-DD HH:mm`)}`
                                                )
                                            ]),
                                            this.$createElement(`div`, null, [
                                                this.$createElement(
                                                    `button`,
                                                    {
                                                        style: {
                                                            'margin-top': `10px`,
                                                            width: `100px`,
                                                            float: `right`
                                                        },
                                                        class: `el-button el-button--primary el-button--mini`,
                                                        on: {
                                                            click: that.notifyClick.bind(that, d, true)
                                                        }
                                                    },
                                                    d.biz_message_content.link_url == null || d.biz_message_content.link_url == `` ? `确定` : `去处理`
                                                )
                                            ])
                                        ]),
                                        duration: 0,
                                        position: `bottom-right`
                                    })
                                    this.notifications[d.biz_message_header_id] = notify
                                })
                            }
                        })
                        if (that.noticeDatas.length > 0) {
                            that.reseveMessage()
                        }
                    } else {
                        for (let key in this.notifications) {
                            this.notifications[key].close()
                            delete this.notifications[key]
                        }
                    }
                } else {
                    for (let key in this.notifications) {
                        this.notifications[key].close()
                        delete this.notifications[key]
                    }
                }
                that.needGetMessage = true
            }).catch(e => {
                console.log(e)
            })
        },
        reseveMessage() {
            let that = this
            for (let i = 0; i < that.noticeDatas.length; i++) {
                that.voiceBroadcast(that.noticeDatas[i])
            }
        },
        voiceBroadcast(message) {
            let that = this
            console.log(`======开始播报========` + message)
            // 在控制台运行检查
            if (`speechSynthesis` in window) {
                console.log(`浏览器支持 Web Speech API`)
            } else {
                console.log(`浏览器不支持 Web Speech API`)
            }
            let synth = window.speechSynthesis
            console.log(`语音合成支持:`, synth ? `是` : `否`)
            if (synth.speaking) {
                // console.log(`上一条语音正在播放，请稍后`)
                return false
            }
            that.noticeDatas.shift()
            let voices = synth.getVoices() // synth.speaking
            console.log(`可用语音列表:`, voices)
            let utterThis = new SpeechSynthesisUtterance(message)
            console.log(`SpeechSynthesisUtterance 对象:`, utterThis)
            for (let i = 0; i < voices.length; i++) {
                if (voices[i].lang == `zh-CN`) {
                    utterThis.voice = voices[i]
                    break
                }
            }
            utterThis.pitch = 1
            utterThis.rate = 0.5
            utterThis.volume = 1
            utterThis.onerror = function(event) {
                console.log(`onerror报错了`)
            }
            console.log(`开始调用speak方法播报`)
            synth.speak(utterThis)
            that.speakFinish = setInterval(function() {
                // console.log(`=====正在播报${synth.speaking}=======`)
                if (!synth.speaking) {
                    console.log(`播报结束`)
                    clearInterval(that.speakFinish)
                }
            }, 1000)
        },
        notifyClick(row, result) {
            let that = this
            // 急诊弹框提醒特殊处理
            if (row.biz_message_content.biz_type == `9`) {
                let menuName = ``
                if (this.emergencyAlertSettings) {
                    let menumodel = JSON.parse(this.emergencyAlertSettings)
                    menuName = (menumodel && menumodel.handle_url) || ``
                }
                // this.emergencyAlertSettings = `{"enum_WorkerRoles":"1,2","handle_url":"手术排程"}`
                let menu = null
                for (var i = 0; i < that.workbar.length; i++) {
                    menu = _.find(that.workbar[i].menu_models, function(m) {
                        return m.name == menuName
                    })
                    if (menu) {
                        break
                    }
                }
                let url = (menu && menu.url) || `/`
                this.$router.push(url)
                return
            }
            if (!row.is_read) {
                let paramuser = row.ac_sys_user_id == 0 ? `&ac_SysUser_Id=0` : ``
                let req = null
                if (row.biz_message_content.biz_type == `3`) {
                    // biz_type =3 是 复苏申请消息，点击弹框 改为 已阅读即可。
                    // status=0 表示 后端不用改数据状态，以前啥状态就啥状态
                    req = this.myaxios.get(`/api/Operation/RecoveryApplyMessage/ChangeApplyMessage?bizId=${row.biz_message_content.biz_id}&status=0&content=&is_handle=true`)
                } else {
                    req = this.myaxios.get(
                        `/api/Operation/MessageReceive/UpdateNotifyReceive?biz_messageheader_id=${row.biz_message_header_id}&result=${result}&remark=${
                            row.biz_message_content.remark == undefined ? `` : row.biz_message_content.remark
                        }&handler_name=${row.biz_message_content.handler_name == undefined ? `` : row.biz_message_content.handler_name}${paramuser}`
                    )
                }
                req.then(data => {
                    this.notifications[row.biz_message_header_id].close()
                    delete this.notifications[row.biz_message_header_id]
                    if (row.biz_message_content.biz_type == `3`) {
                        // biz_type =3 是 复苏申请消息
                        row.biz_message_content.result = result

                        let senddata = row.biz_message_content
                        // 发送sorket
                        _.each(senddata, (value, key) => {
                            /* eslint valid-typeof: "error" */
                            if (senddata[key] && (senddata[key] + ``).indexOf(`/Date`) > -1) {
                                senddata[key] = this.$moment(senddata[key]).format(`YYYY/MM/DD HH:mm`)
                            }
                        })
                        let msgData = JSON.stringify(senddata)
                        let req = this.myaxios.post(`/api/Operation/BoardNotice/SendMessage?msg=${msgData}`)
                        req.then(data => {
                            this.$message.info(`已通知`)
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                    if (row.biz_message_content.link_url != null && row.biz_message_content.link_url != ``) {
                        var w = this.screenWidth - 10
                        var h = this.screenHeight - 10
                        if (typeof winformMsg != `undefined`) {
                            w = w + 500
                            h = h + 400
                        }
                        window.open(row.biz_message_content.link_url, ``, `width=${w},height=${h},top=10,left=10`)
                    }
                }).catch(e => {})
            }
        },
        getShortcut(str) {
            return this.collapse ? str.substr(0, 2) : str
        },
        activeWard(ward) {
            this.$store.commit(`SET_ACTIVE_WARD`, ward)
            sessionStorage.setItem(`active_ward`, JSON.stringify(ward))
            this.display = false
            this.urlActiveWard = null
        },
        logoutbody() {
            this.applyThemeByConfigMode(this.$root.DefaultThemeColorMode)
            this.$router.replace(`/login`).then(() => {
                // 清除记忆功能
                this.removeSession()
                location.reload()
            })
        },
        logoutca() {
            this.applyThemeByConfigMode(this.$root.DefaultThemeColorMode)
            let redirect = this.$route.query.redirect
            if (!redirect || redirect == `undefined`) redirect = ``
            let gourl = `${this.$root.CaLoginUrl}?app_key=${this.$root.appKey}&redirect=${redirect}`
            // 清除记忆功能
            this.removeSession()
            window.location.href = gourl
        },
        logout() {
            // 在这里记录登录日志
            let clientPath = ``
            if (window.ClientPath) {
                clientPath = window.ClientPath.clientPath
            }
            let req2 = this.myaxios.post(`/api/AcisSystem/Authorization/Logout?clientPath=${clientPath}`)
            req2.then(data => {
                sessionStorage.removeItem(`token`)
                if (data && data.status && data.data && data.data.transUrl) {
                    this.applyThemeByConfigMode(this.$root.DefaultThemeColorMode)
                    this.removeSession()
                    window.location.href = data.data.transUrl
                } else {
                    if (this.useCa == `1`) {
                        this.$store.dispatch(`Get_Menu`).then(menus => {
                            console.log(menus)
                            if (menus.findIndex(item => item.code === `6298723fae9d12ba9730c36787e868e8`) == -1) {
                                this.logoutbody()
                            } else {
                                this.logoutca()
                            }
                        })
                    } else {
                        this.logoutbody()
                    }
                }
            }).catch(e => {
                console.log(e)
            })
        },
        // 测试重新登录功能（模拟Token过期）
        // testRelogin() {
        //     this.$confirm(`这将模拟Token过期场景，触发重新登录流程`, `测试提示`, {
        //         confirmButtonText: `确定`,
        //         cancelButtonText: `取消`,
        //         type: `warning`
        //     }).then(() => {
        //         console.log(`========== 开始测试重新登录功能 ==========`)
        //         showExpiredDialog()
        //     }).catch(() => {
        //         this.$message.info(`已取消测试`)
        //     })
        // },
        // 清除session记忆功能
        removeSession() {
            sessionStorage.removeItem(`consd`)
            sessionStorage.removeItem(`consdrs`)
            sessionStorage.removeItem(`memory_leftCalendar`)
            sessionStorage.removeItem(`memory_rightCalendar`)
            sessionStorage.removeItem(`BasicTabUpDown`)
            sessionStorage.removeItem(`memory_operating_ward_id`)
            sessionStorage.removeItem(`active_ward`)
            sessionStorage.removeItem(`surgery_query`)
            sessionStorage.removeItem(`doctoken`)
        },
        alterPassword() {
            this.alterPasswordDialogVisible = true
        },
        // added by xiaorui，重置首页
        ResetHomePage() {
            return new Promise(resolve => {
                let req = this.myaxios.delete(`/api/AcisSystem/HomePageOrderConfig/DelUserPageConfig?userName=${this.currentUser.username}&pageName=IndexPage`)
                req.then(data => {
                    // 触发首页重置排序事件
                    this.$store.commit(`layout/SET_RESET`, !this.reset)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        showUserInfo() {
            // console.log(1)
            // 用户信息展示
        },
        preferencesSetting() {
            // 偏好设定
        },
        changeUser() {
            // 切换用户
        },
        changeLangEvent() {
            this.$confirm(`确定切换语言吗?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    if (this.$i18n.locale === `zh-CN`) {
                        this.$i18n.locale = `en-US` // 关键语句
                    } else {
                        this.$i18n.locale = `zh-CN` // 关键语句
                    }
                })
                .catch(() => {})
        },
        triggerTags() {
            // 显示隐藏tagsview
            // this.enable_tagsview = !this.enable_tagsview
            this.$emit(`update:enable_tagsview`, !this.enable_tagsview)
        },
        triggerCollapse() {
            // 显示隐藏collapse
            this.$store.commit(`layout/SET_COLLAPSE`, !this.collapse)
            if (this.containerWidth > 0) {
                if (!this.collapse) {
                    this.$store.commit(`setContainerWidth`, this.containerWidth - 200)
                } else {
                    this.$store.commit(`setContainerWidth`, this.containerWidth + 200)
                }
            }
            this.$emit(`update:collapse`, !this.collapse)

            this.$nextTick(function() {
                // ACIS-24203 【质控】隐藏左侧图标时，界面支持自适应,iframe第三方页面时，刷新iframe
                let iframe = document.getElementById(`thirdIframe`)
                if (iframe) {
                    iframe.setAttribute(`src`, iframe.src)
                }
            })
        },
        changeTheme(_theme) {
            let theme = localStorage.getItem(`app_theme`)
            // theme-his-blue 需要保留 theme-dark 作为 Element UI 基础样式的作用域
            let bodyClass = _theme
            if (_theme === `theme-his-blue`) {
                bodyClass = `theme-dark theme-his-blue`
            }
            if (theme !== _theme) {
                document.getElementById(`app`).parentElement.className = bodyClass
                localStorage.setItem(`app_theme`, _theme)
            } else {
                document.getElementById(`app`).parentElement.className = bodyClass
            }
            window.dispatchEvent(new CustomEvent(`app-theme-changed`, { detail: { theme: _theme } }))
        },
        change_theme_light() {
            this.changeTheme(`theme-light`)
        },
        change_theme_dark() {
            this.changeTheme(`theme-dark`)
        },
        change_theme_his_blue() {
            this.changeTheme(`theme-his-blue`)
        },
        applyThemeByConfigMode(mode) {
            const modeVal = `${mode || `1`}`
            let theme = `theme-dark`
            if (modeVal === `2`) {
                theme = `theme-light`
            } else if (modeVal === `3`) {
                theme = `theme-his-blue`
            }
            localStorage.setItem(`app_theme`, theme)

            let bodyClass = theme
            if (theme === `theme-his-blue`) {
                bodyClass = `theme-dark theme-his-blue`
            }
            const appRoot = document.getElementById(`app`)
            if (appRoot && appRoot.parentElement) {
                appRoot.parentElement.className = bodyClass
            }
            window.dispatchEvent(new CustomEvent(`app-theme-changed`, { detail: { theme } }))
        },
        dropDownAction(command) {
            console.log(command)
            if (command.indexOf(`extend`) > -1) {
                let extendList = command.split(`|`)
                if (extendList && extendList.length > 1) {
                    console.log(extendList)
                    let req = this.myaxios.get(`/api/Operation/MessageHeader/ExecSendMessageExtend?extendvalue=${extendList[1]}`)
                    req.then(data => {
                        this.$message.success(`发送成功！`)
                    }).catch(e => {
                        console.log(e)
                    })
                }
            } else {
                this[command] && this[command]()
            }
        },
        loadWorkstationConfig() {
            return new Promise(resolve => {
                console.log(this[`localip/ipAddress`])
                if (!this[`localip/ipAddress`]) return
                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${this[`localip/ipAddress`]}`)
                req.then(data => {
                    if (data) {
                        this.operating_room_id = data.dic_operating_room_id
                        let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${data.dic_operating_room_id || 0}`)
                        req1.then(d => {
                            this.active_id = (d && d.dic_operating_ward_id) || data.dic_recovery_ward_id
                        }).catch(e => {
                            console.log(e)
                        })
                        resolve(data)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        }
    }
}
</script>
<style scoped lang="less">
.collapse {
    line-height: 50px;
    font-size: 26px;
    color: #1f2d3d;
}

.collapse:hover {
    color: darkgoldenrod !important;
}

.el-footer {
    /*height: 20px;*/
    font-size: 12px;
    background: darkgray;
    color: whitesmoke;
}

.cus-sider {
    transition: width 0.3s ease-out;
}

.fg-info {
    background: #f1f3f4;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.el-button {
    margin-left: 0px !important;
    margin-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Index.vue